import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from 'react-redux';
import store from "store";
import { SET_OUTSOURCING_CONTRACT_STATE } from "store/auth/data/actionTypes";

import OutsourcingContractFinish from "./OutsourcingContractFinish";
import OutsourcingUncontracted from "./OutsourcingUncontracted";

const style = { fontSize: 14 };

const clickedStyle = { backgroundColor: "#48C3B1", color: "#ffffff" };

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const OutsourcingContractManagementScreen = () => {
  const selector = useSelector(state => state)
  const history = useHistory()
  // 계약완료 / 미계약
  const [contractState, setContractState] = useState(selector.Data.outsourcingContractState)
  const [searchCondition, setSearchCondition] = useState({})
  const [listCount, setListCount] = useState(0)
  const [searchState, setSearchState] = useState(0)

  const changeContractState = async (str) => {
    await store.dispatch({ type: SET_OUTSOURCING_CONTRACT_STATE, data: [str] });
    setContractState(str);
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const getListLength = (length) => {
    setListCount(length)
  }

  const onSearch = () => {
    setSearchState(prev => prev + 1)
  }

  useEffect(() => {
    setSearchCondition({})
    setSearchState(0)
  }, [contractState])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>지입 계약 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" breadcrumbItem="지입 계약 관리" />

          <Row>
            <Col xl={5} lg={8} md={12}>
              <div className="d-flex w-100 gap-30 align-items-center mb-3">
                <div className="email-rightbar flex-grow-1">
                  <Card className="mb-0">
                    <CardBody className="padding-0">
                      <table className="input-table">
                        <tbody>
                          <tr>
                            <td className="col-10 padding-left-8 primary-bg white-text font-size-12">수탁 업체명</td>
                            <td className="col-20">
                              <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="업체명을 입력하세요." value={searchCondition.companyName || ''} onChange={(e) => {
                                changeSearchCondition('companyName', e.target.value)
                              }} />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </CardBody>
                  </Card>
                </div>
                <div className="d-flex flex-direction-column align-items-end">
                  <button type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0" onClick={() => {
                    onSearch()
                  }}>
                    검색
                  </button>
                </div>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center mb-2 margin-top-40 justify-content-between">
            <div className="d-flex align-items-center">
              <button style={{ width: 100, height: 35 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 ${contractState == 'contractFinish' ? selectedClass : unselectedClass}`} onClick={() => {
                changeContractState('contractFinish')
              }}>
                계약완료
              </button>
              <button style={{ width: 100, height: 35 }} type="button" className={`custom-btn border-radius-0 font-size-11 line-height-1 ${contractState == 'uncontracted' ? selectedClass : unselectedClass}`} onClick={() => {
                changeContractState('uncontracted')
              }}>
                계약대기
              </button>
              <p className="mb-0 font-size-16"><span className="font-weight-bold">계약 목록</span> [ 건수 : {listCount}건 ]</p>
            </div>
            <button style={{ width: 100, height: 35 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none`} onClick={() => {
              history.push('/outsourcing-contract-management-screen-write')
            }}>
              신규계약
            </button>
          </div>

          {contractState == "contractFinish" && <OutsourcingContractFinish getListLength={getListLength} searchState={searchState} searchCondition={searchCondition} />}
          {contractState == "uncontracted" && <OutsourcingUncontracted getListLength={getListLength} searchState={searchState} searchCondition={searchCondition} />}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default OutsourcingContractManagementScreen
